/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconWaterDrop: {
  name: 'water_drop';
  data: string;
} = {
  name: 'water_drop',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 612 612"><path d="M67.287 288.477c1.921 7.685-4.031 14.344-11.953 14.344s-13.898-6.565-11.953-14.344c1.195-4.781 7.172-11.953 11.953-23.906 4.781 11.952 10.758 19.125 11.953 23.906z" transform="matrix(15 0 0 15 -523.957 -3949.433)"/></svg>`,
};
